<template>
  <div>
    <div class="mt-1 mb-3 pl-3 pr-3">
      <div class="row align-items-end">
        <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
          <p class="text-uppercase mb-1" 
            :class="pathwayStepsData.mentee_pathway.currentStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" >
            <span :style="pathwayStepsData.mentee_pathway.currentStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
          </p>
          <div class="progress progress_pathway">
            <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
          </div>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['active', 'mentee_id', 'pathwayStepsData'],
  data() {
    return {
      activeStep: '',    
    }
  },
  methods: {
    
  },
  computed: {
    
  },
  created() {
    
  },
}
</script>

<style scoped>
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_pathway_progress.vue